
    <no-content
      [isLoggedIn]="isLoggedIn$ | async"
      [isPrivateOrgMode]="isPrivateOrgMode$ | async"
      [currentRoute]="currentRoute"
    ></no-content>
  